import { Spin } from "antd";
import { FC } from "react";
import { useParams } from "react-router-dom";

import FlexContainer from "@/components/FlexContainer";
import DashboardTabs from "@/pages/Dashboard/DashboardTabs";
import { Salary } from "@/pages/Dashboard/Salary";

import { StyledDashboardTab } from "./Styled";

interface IDashboardTab {
    isLoaded: boolean;
}

export const DashboardTab: FC<IDashboardTab> = ({ isLoaded }) => {
    const { userId } = useParams();

    if (!isLoaded) {
        return (
            <FlexContainer
                justifyContent="center"
                alignItems="center"
                width="100%"
                style={{ padding: "40px 0" }}
            >
                <Spin size="large" />
            </FlexContainer>
        );
    }

    return (
        <StyledDashboardTab>
            <Salary targetDB="db-ta" />
            <DashboardTabs userId={userId} />
        </StyledDashboardTab>
    );
};
